export enum InvoiceLinesRequestStatus {
  READY = 'READY',
  OBSOLETE = 'OBSOLETE',
  PROCESSING = 'PROCESSING',
}
